module.exports = __webpack_public_path__ + "static/media/RAHUL-BANGABASH.bec3787c.png";